import React, { Component } from 'react'
import { checkTranslation, chooseWallpaper, conditionalWidth, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import CustomLoader from '../../components/CustomLoader';
import { nanoid } from 'nanoid';
import FormViewer from '../../components/FormViewer';
import RangeNumberInput from '../../components/inputs/RangeNumberInput';
import { countriesList } from '../../variables/countries';
import SelectInput from '../../components/inputs/SelectInput';
import DateInput from '../../components/inputs/DateInput';
import HttpServices from '../../utils/Http.services';
import SwitchInput from '../../components/inputs/SwitchInput';

class CHPricingInfo extends Component {

    state = {
        display: true,
        headers: [
            { key: 'invoice', type: 'InvoiceInput2', information: { required: true, placeholder: '{{lang}}Quantity', } },
        ],
        formHeaders: [
            { key: 'country', type: 'TextInput', col: '6', information: { label: '{{lang}}Country/Region', required: true, placeholder: '{{lang}}Country', } },
            { key: 'province', type: 'TextInput', col: '6', information: { label: '{{lang}}Province/State', required: true, placeholder: '{{lang}}Province', } },
            { key: 'city', type: 'TextInput', col: '6', information: { label: '{{lang}}City', required: true, placeholder: '{{lang}}City', } },
            { key: 'zipcode', type: 'NumberInput', col: '6', information: { label: '{{lang}}Zip Code', required: true, placeholder: '{{lang}}Zip Code', type: 'api', address: 'searchUser', filter: {}, fields: { title: 'fullname', value: '_id', description: 'username', image: 'image' } } },
            { key: 'company', type: 'TextInput', col: '6', information: { label: '{{lang}}Company', required: true, placeholder: '{{lang}}Company', } },
            { key: 'address', type: 'TextInput', col: '6', information: { label: '{{lang}}Address', required: true, placeholder: '{{lang}}Address', } },
            { key: 'taxId', type: 'NumberInput', col: '6', information: { label: '{{lang}}Tax ID', required: false, placeholder: '{{lang}}Tax ID', } },
        ],
        priceHeaders: [
            { key: 'quantity', col: '6', type: 'NumberInput', information: { required: true, placeholder: '{{lang}}Quantity', label: '{{lang}}Quantity', } },
            // { key: 'service', col: '6', type: 'NumberInput', information: { required: true, placeholder: '{{lang}}Service period', label: '{{lang}}Service period (by Year)', } },
            { key: 'serviceTime', col: '6', type: 'SelectInput', information: { required: true, items: [{ title: '{{lang}}Monthly', value: 'monthly' }, { title: '{{lang}}Yearly', value: 'yearly' }], placeholder: '{{lang}}Service period', label: '{{lang}}Service period (by Year)', } },
            { key: 'subscription', col: '12', type: 'SwitchInput', information: { placeholder: '{{lang}}Subscription', label: '{{lang}}Subsctiption', } },
        ]
    }

    componentDidMount() {
        let countries = countriesList
        let currenciesItems = []
        countries.forEach(country => {
            let currencyItem = { title: `${country.currency} (${country.symbol})`, value: country.code }
            currenciesItems.push(currencyItem)
        });
        this.setState({ currenciesItems })
        console.log('this.props.status', this.props.status)
        if (this.setHeader) {
            this.setHeader({
                'toolbar': null,
                'showToolbar': false,
                'info': 'Create Hub | Pricing Info',
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.lastStage()
            })
        }
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextClicked}
                    isLoading={this.state.isLoading}
                    title={translate("Next Step")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }

    nextClicked = () => {
        let billingInfo = this.form.getForm()
        let serviceInfo = this.priceForm.getForm()
        if (billingInfo && serviceInfo) {
            this.props.setData({ billingInfo, serviceInfo }, () => {
                this.props.changeStage("info")
            })
        }

        // if (status == 0) {
        //     if (this.props.initData?.category) {
        //         this.props.changeStage("info")
        //     }
        // }
        // if (status == 2) {
        //     // this.props.changeStage("info")
        // }
        // else {
        //     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.ContentEmpty' })
        // }
    }

    checkout = () => {
        let data = this.priceForm.getForm()
        let body = { quantity: this.props.initData?.quantity, serviceType: this.props.initData?.serviceType, subscription: data?.subscription, expiry: { value: this.props.initData?.service, unit: 'year' } }
        HttpServices.request('checkoutWithStripe', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            // console.log('fetchResult', fetchResult.info.url)
            window.location.href = fetchResult.info.url
        })
    }

    changeType = (prop, index) => {
        this.props.setData({ category: prop.name }, () => {
        })
    }

    toggleDisplay = () => {
        this.setState(prevState => ({
            display: !prevState.display
        }))
    }
    setInputData = (key, value, extra) => {
        console.log('key,value,extra', key, value, extra)
        let data = JSON.parse(JSON.stringify(this.props.initData))
        if (value) {

            data[key] = value
        } else {
            data[key] = null
        }
        this.props.setData(data, () => {
            console.log('this.props.initDatap', this.props.initData)
        })
    }
    render() {
        // console.log('this.propsss',this.props)
        return (
            <div className=" w-100 h-100  position-relative window-content-radius" style={{}}>
                <div className='w-100' style={{ position: 'sticky', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div>
                <div className={'d-flex scroll-no-scrollbar ' + (conditionalWidth(this.props.width, { xs: 'flex-column', lg: 'flex-row' }))} style={{ height: 'calc(100% - 46px)', padding: '4% 6%', background: "rgba(245, 228, 255, 35%)" }}>
                    <Responsive className={" px-2 py-2 " + (conditionalWidth(this.props.width, { xs: '', lg: 'h-100' }))} width={this.props.width} media={{ xs: '12', sm: '12', md: '12', lg: "7", xl: "8" }}>
                        <div className=' w-100 flexc h-100 flex-column' style={{}} >
                            {Array.isArray(this.props.pricingData) && this.props.pricingData.map((item, index) => {
                                return (
                                    <>
                                        {item.buttons.map((buttun, bindex) => {
                                            if (buttun.status == this.props.status) {
                                                return (
                                                    <div className='br-10 w-100 px-3' style={{ background: '#fff' }}>
                                                        <div className='flexcb pt-4 '>
                                                            <p className='font-size-16 weight-600 main-c2'>{translate('Product')}</p>
                                                            <p className='font-size-16 weight-600 main-c2'>{translate('Hub')} {checkTranslation(item.title)}</p>
                                                        </div>
                                                        <div className="br-10 my-3" style={{ border: '1px solid #eee' }}>
                                                            <div className='brt-10 px-4 py-3' style={{ background: this.props.colors ? this.props.colors?.background : '#f9f9f9', }}>
                                                                <p style={{ color: this.props.colors ? this.props.colors?.textColor : '#222' }}>{translate('Hub')} {checkTranslation(item.title)}</p>
                                                            </div>
                                                            <div className="d-flex flex-column w-100 pt-3" style={{ textAlign: 'start' }}>
                                                                {item.options.list.map((prop, pindex) => {
                                                                    return (
                                                                        <div className='flexc pb-3 px-4' style={{ alignItems: 'start' }}>
                                                                            <img src='/assets/icons/tick-pricing.svg' className='mrd-2' />
                                                                            <p className="" style={{ color: 'rgb(100, 106, 115)', fontSize: '13px', textAlign: 'start', fontWeight: 500, }}>{checkTranslation(prop)}</p>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                        {/* <div className='mt-3 ' >
                                                            <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} errors={this.state.errors} inputClass={'modern-input-pricing'} nopadding={true} setData={this.props.setData} />
                                                        </div> */}
                                                        {/* */}

                                                        <div className="py-3 px-4">
                                                            {/* <div className='flexcb pb-2'>
                                                                <p className='font-size-14 weight-600 main-c2'>{translate('Quantity')}</p>
                                                                <div className='d-flex flex-column' style={{ alignItems: 'flex-end' }}>
                                                                    <div style={{ maxWidth: '100px' }}>
                                                                        <RangeNumberInput data={this.props.data?.quantity} header={{ key: '', information: {} }} changeValue={() => this.setInputData()} />
                                                                    </div>
                                                                    <p className='font-size-12 main-c7'>Current organization has 3 members, at least purchase 3seats</p>
                                                                </div>
                                                            </div> */}
                                                            <div className='flexcb pb-2'>
                                                                <FormViewer ref={el => this.priceForm = el} headers={this.state.priceHeaders} errors={this.state.errors} inputClass={'modern-input'} nopadding={true} setData={this.props.setData} />

                                                                {/* <p className='font-size-14 weight-600 main-c2'>{translate('Subscription')}</p>
                                                                <div className='d-flex flex-column' style={{ alignItems: 'flex-end' }}>
                                                                    <div style={{ maxWidth: '100px' }}>
                                                                        <SwitchInput data={this.props.initData.subscription} header={{ key: 'subscription', information: {} }} changeValue={this.setInputData} />
                                                                    </div>
                                                                    <p className='font-size-12 main-c7'>Current organization has 3 members, at least purchase 3seats</p>
                                                                </div> */}
                                                            </div>
                                                            {/* */}
                                                            {/* <div className='flexcb py-2'>
                                                                <p className='font-size-14 weight-600 main-c2'>{translate('Service period')}</p>
                                                                <div className='flexc' style={{}}>
                                                                    <div className='prd-2' style={{ maxWidth: '100px' }}>
                                                                        <RangeNumberInput data={this.props.data?.service} header={{ key: '', information: {} }} changeValue={() => { }} />
                                                                    </div>
                                                                    <p className='font-size-12 main-c2'>year</p>
                                                                </div>
                                                            </div> */}
                                                            {/* <div className='flexcb py-2'>
                                                                <p className='font-size-14 weight-600 main-c2'>{translate('Time zone')}</p>
                                                                <div className='br-6 w-100' style={{ maxWidth: '130px', backgroundColor: '#fff', border: '1px solid #e2e2e2', padding: '4px 6px' }}>
                                                                    <SelectInput data={this.props.data?.currency} header={{ key: '', information: { items: this.state.currenciesItems } }} changeValue={() => { }} />
                                                                </div>
                                                            </div>
                                                            <div className='flexcb py-2'>
                                                                <p className='font-size-14 weight-600 main-c2'>{translate('Start time')}</p>
                                                                <div className='br-6 w-100' style={{ maxWidth: '130px', backgroundColor: '#fff', border: '1px solid #e2e2e2', padding: '4px 6px' }}>
                                                                    <DateInput data={this.props.data?.start} header={{ key: '', information: {} }} changeValue={() => { }} />
                                                                </div>
                                                            </div>
                                                            <div className='flexcb pt-2'>
                                                                <p className='font-size-14 weight-600 main-c2'>{translate('End time')}</p>
                                                                <p className='font-size-14 main-c2'>12/08/2024 23:59:59</p>
                                                            </div> */}
                                                        </div>
                                                        <div className='py-4 mt-3 px-4' style={{ borderTop: '1px solid #eee' }}>
                                                            <div className='flexcb pb-2'>
                                                                <p className='font-size-14 weight-600 main-c2'>{translate('Billing Information')}</p>
                                                                {/* <div className='flexc' style={{}}>
                                                                    <div className="mrd-1">
                                                                        <ButtonAnimated
                                                                            bg={'rgba(120, 120, 120, 0.1)'}
                                                                            textColor={'rgb(120, 120, 120)'}
                                                                            title={'{{lang}}Cancel'}
                                                                            onClick={() => { }}
                                                                        />
                                                                    </div>
                                                                    <div className="mld-1">
                                                                        <ButtonAnimated
                                                                            icon={'/assets/icons/check-white.svg'}
                                                                            bg={this.props.colors?.background}
                                                                            textColor={this.props.colors?.textColor}
                                                                            title={'{{lang}}Save and Continue'}
                                                                            onClick={() => { }}
                                                                        />
                                                                    </div>
                                                                    <div className="mld-2">

                                                                        <ButtonAnimated
                                                                            icon={'/assets/icons/check-white.svg'}
                                                                            bg={this.props.colors?.background}
                                                                            textColor={this.props.colors?.textColor}
                                                                            title={'{{lang}}Checkout'}
                                                                            onClick={() => { this.checkout() }}
                                                                        />
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                            <div>
                                                                <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} errors={this.state.errors} inputClass={'modern-input'} nopadding={true} setData={this.props.setData} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })
                                        }

                                    </>

                                )
                            })}
                        </div>
                    </Responsive>
                    <Responsive className={" px-2 py-2 " + (conditionalWidth(this.props.width, { xs: '', lg: 'h-100' }))} width={this.props.width} media={{ xs: '12', sm: '12', md: '12', lg: "5", xl: "4" }}>
                        <div className='br-10 w-100' style={{ background: '#fff' }}>
                            <div className='brt-10 px-4 py-3' style={{ background: this.props.colors ? this.props.colors?.background : '#f9f9f9', }}>
                                <p style={{ color: this.props.colors ? this.props.colors?.textColor : '#222' }}>{translate('Order Summery')}</p>
                            </div>
                            <div className="py-3 px-4">
                                <FormViewer ref={el => this.orderForm = el} headers={this.state.headers} errors={this.state.errors} inputClass={'modern-input-pricing'} nopadding={true} setData={this.props.setData} />
                            </div>
                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CHPricingInfo);
// export default CHPricing;